import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAccountCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.95 10.25a6.7 6.7 0 0 1 1.925-.942A7.3 7.3 0 0 1 7 9q1.1 0 2.125.308 1.025.309 1.925.942.584-.684.867-1.517A5.4 5.4 0 0 0 12.2 7q0-2.161-1.52-3.68T6.996 1.8t-3.68 1.52T1.8 7q0 .9.283 1.733.284.833.867 1.517M7 8.2a2.31 2.31 0 0 1-1.7-.7 2.31 2.31 0 0 1-.7-1.7q0-1 .7-1.7A2.31 2.31 0 0 1 7 3.4q1 0 1.7.7t.7 1.7-.7 1.7-1.7.7m.005 5.2a6.25 6.25 0 0 1-2.488-.5 6.5 6.5 0 0 1-2.042-1.375A6.5 6.5 0 0 1 1.1 9.484a6.3 6.3 0 0 1-.5-2.492 6.2 6.2 0 0 1 .5-2.484A6.453 6.453 0 0 1 4.516 1.1 6.3 6.3 0 0 1 7.008.6a6.2 6.2 0 0 1 2.484.5A6.48 6.48 0 0 1 12.9 4.512q.5 1.163.5 2.483t-.5 2.488A6.45 6.45 0 0 1 9.488 12.9q-1.162.5-2.483.5M7 12.2q.867 0 1.667-.275a5.3 5.3 0 0 0 1.5-.808 6 6 0 0 0-1.517-.684A5.9 5.9 0 0 0 7 10.2q-.85 0-1.658.225-.81.225-1.509.692.7.533 1.5.808A5.1 5.1 0 0 0 7 12.2M7 7q.5 0 .85-.35t.35-.85-.35-.85A1.16 1.16 0 0 0 7 4.6q-.5 0-.85.35t-.35.85.35.85T7 7"
    />
  </svg>
);
export default SvgAccountCircle;
